import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_GuardianTypeSetup } from "../shared/data.service";
import { ParentRelationshipInsertRequest } from "../shared/ParentRelationshipInsertRequest";
import { StringIntRequest } from "../shared/StringIntRequest";

@Component({
	selector: "app-add-guardian-type",
	templateUrl: "./add-guardian-type.component.html",
	styleUrls: ["./add-guardian-type.component.css"],
})
export class AddGuardianTypeComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private GuardianTypeSetupService: DataService_GuardianTypeSetup
	) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;
		this.SchoolID = this.dialogConfig.data.SchoolID;
	}

	////////////////////////////////
	// Data
	////////////////////////////////

	user: any;
	SchoolID: any;

	//Form
	GuardianCD: any = "";
	GuardianDesc: any = "";

	errorMessage: any = "";

	////////////////////////////////

	////////////////////////////////
	// Buttons
	////////////////////////////////
	onAdd() {
		if (this.GuardianCD == "") {
			this.errorMessage = "Enter a code";
			return;
		} else if (this.GuardianDesc == "") {
			this.errorMessage = "Enter a description";
			return;
		} else {
			this.CheckCD();
		}
	}

	CheckCD() {
		let parms: StringIntRequest = {
			str: this.GuardianCD,
			num: this.SchoolID,
		};

		var result = this.GuardianTypeSetupService.ParentRelationshipCDUsed(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Guardian Type Code/Abbreviation Already in Use";
					return;
				} else {
					this.CheckDesc();
				}
			},
			(error) => {}
		);
	}

	CheckDesc() {
		let parms: StringIntRequest = {
			str: this.GuardianDesc,
			num: this.SchoolID,
		};

		var result = this.GuardianTypeSetupService.ParentRelationshipDescUsed(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Guardian Type Name/Description Already in Use";
					return;
				} else {
					this.FinishAdd();
				}
			},
			(error) => {}
		);
	}

	FinishAdd() {
		var DFB = this.user.UserLevelID == 3 ? 3 : 4;

		let parms: ParentRelationshipInsertRequest = {
			RelationshipCD: this.GuardianCD,
			RelationshipDesc: this.GuardianDesc,
			DefinedByID: DFB,
			SchoolID: this.SchoolID,
		};

		var result = this.GuardianTypeSetupService.ParentRelationshipInsert(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Guardian Type was added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the Guardian Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////
}
